import { PremiumDueResponseDtoPremiumStatusEnum } from 'libs/pinnacle-sdk';

export interface PremiumDueData {
  key: string;
  index: number;
  broker: string;
  reinsured: string;
  insured: string;
  binder: string;
  pinnacleRefNo: string;
  description: string;
  currency: string;
  netAmountDueFromBroker: number;
  balanceNetAmountDue: number;
  premiumStatus: PremiumDueResponseDtoPremiumStatusEnum;
  ppwDueDate: string;
}

export enum EPremiumDueTabs {
  Paid = 'paid',
  Unpaid = 'unpaid',
}
